import { SxProps } from '@mui/material'

const styles = {
  modalBody: {
    maxHeight: '70vh',
    overflow: 'auto',
    paddingRight: 1
  } as SxProps,

  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  } as SxProps,

  productImage: {
    width: '100%',
    maxWidth: 40,
    height: 'auto',
    objectFit: 'contain',
    borderRadius: 2
  } as SxProps,

  productDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  } as SxProps,

  productName: {
    fontWeight: 600,
    lineHeight: 1.3
  } as SxProps,

  productInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5
  } as SxProps,

  description: {
    marginTop: 1
  } as SxProps,

  sectionTitle: {
    fontWeight: 600,
    marginBottom: 1
  } as SxProps,

  deliveryInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1
  } as SxProps,

  flightInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1
  } as SxProps,

  travelerInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1
  } as SxProps,

  readinessInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1
  } as SxProps,

  infoLabel: {
    fontWeight: 500,
    color: 'text.secondary'
  } as SxProps,

  lastEvaluated: {
    marginTop: 1
  } as SxProps
}

export default styles
